/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemRefSchema = z.object({
  externalKey: z.string().nullish(),
  itemId: z.int(),
  name: z.string(),
});
